import { useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

import { ROUTES } from 'configs/routes';

/**
 * Хук для определения видимости хедера на основе текущего pathname
 * Скрывает хедер на страницах детального просмотра проектов
 */
export const useHeaderVisibility = (): boolean => {
  const location = useLocation();

  return useMemo(() => {
    // Список путей, где хедер должен быть скрыт
    const hiddenHeaderPaths = [ROUTES.lk.projects.detail.path];

    // Проверяем, соответствует ли текущий путь одному из путей, где хедер скрыт
    return !hiddenHeaderPaths.some((hiddenPath) => {
      return matchPath({ path: hiddenPath }, location.pathname);
    });
  }, [location.pathname]);
};
